import "./ProximosShowsSection.css";

const events = [
  {
    id: 1,
    date: "2026-04-04T12:00:00",
    description: "Desterro Autoral Festival – Brasil Papaya e convidados",
    location: "Florianópolis - Trapiche da Beira-Mar Norte",
    ticketUrl: ""
  }
];

const ProximosShowsSection = () => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    }).toUpperCase();
  };

  return (
    <div className="proximos-shows">
      <div className="shows-section-show">
        <h2 className="shows-title">Próximos Shows</h2>

        {events.length === 0 ? (
          <div className="no-events">Nenhum show agendado no momento</div>
        ) : (
          events.map((event) => (
            <div key={event.id} className="shows-container-show">
              <div className="shows-content-show">

                <div className="show-item-show">
                  <div className="data-and-local">
                    <div className="show-text-show">
                      <div className="show-data">{formatDate(event.date)}</div>
                      <div className="show-place">{event.description}</div>
                    </div>
                  </div>
                </div>

                <div className="show-item-show">
                  <div className="show-address-show">
                    <img className="icon" src="location_on.svg" alt="Localização" />
                    <p className="local-show">{event.location}</p>
                  </div>
                </div>

                <div className="show-item-show">
                  <button
                    className="buy-ticket-btn"
                    onClick={() => event.ticketUrl && window.open(event.ticketUrl, "_blank")}
                  >
                    {event.ticketUrl ? "Comprar Ingresso" : "Entrada Gratuita"}
                  </button>
                </div>

              </div>
            </div>
          ))
        )}

      </div>
    </div>
  );
};

export default ProximosShowsSection;